<template>
	<v-alert outlined dismissible dense v-if="show">
		<app-row>
			<app-cell sm="6" xs="12"><span>Click "Subscribe" to allow web notifications</span></app-cell>
			<app-cell sm="6" xs="12" class="text-right">
				<app-button small :loading="loading" @click="onSubscribe">Subscribe</app-button>
			</app-cell>
		</app-row>
	</v-alert>
</template>

<script>
export default {
	async mounted() {
		this.supported = this.$webpush.constructor.isSupported

		const permissionState = await this.$webpush.getPermissionState()
		this.allowed = permissionState !== 'denied'
		if (this.supported && this.allowed) {
			this.subscribed = await this.$webpush.isSubscribed()
		}

		this.init = true
	},
	computed: {
		show() {
			return this.init && this.supported && !this.subscribed && this.allowed
		},
	},
	data() {
		return {
			subscribed: false,
			supported: false,
			allowed: true,
			loading: false,
			init: false,
		}
	},
	methods: {
		async onSubscribe() {
			this.loading = true

			try {
				const subscription = await this.$webpush.subscribe()

				await this.$ravello.request().to('subscriptions').to('web').create({
					data: JSON.stringify(subscription),
				})
				this.subscribed = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
				this.allowed = false
			}
			this.loading = false
		},
	},
}
</script>
